import { createSlice } from '@reduxjs/toolkit';

const financeSlice = createSlice({
  name: 'finance',
  initialState: {
    payout: { statusHash: {}, players: { 1: [] }, filter: {}, info: {} },
    deposit: { gates: [], statusHash: {}, players: { 1: [] }, filter: {}, info: {} }
  },
  reducers: {
    setDepositGates: (state, action) => {
      state.deposit.gates = action.payload;
    },
    setDepositStatuses: (state, action) => {
      state.deposit.statusHash = action.payload;
    },
    setDepositPlayers: (state, action) => {
      const { groupId, data } = action.payload;
      state.deposit.players[groupId] = data;
    },
    setPayoutStatuses: (state, action) => {
      state.payout.statusHash = action.payload;
    },
    setPayoutPlayers: (state, action) => {
      const { groupId, data } = action.payload;
      state.payout.players[groupId] = data;
    },
    setPayoutInfo(state, action) {
      state.payout.info = action.payload;
    },
    setPayoutFilter(state, action) {
      state.payout.filter = action.payload;
    },
    setDepositInfo(state, action) {
      state.deposit.info = action.payload;
    },
    setDepositFilter(state, action) {
      state.deposit.filter = action.payload;
    }
  }
});

export default financeSlice.reducer;

export const {
  setDepositGates,
  setDepositStatuses,
  setDepositPlayers,
  setPayoutStatuses,
  setPayoutPlayers,
  setPayoutInfo,
  setPayoutFilter,
  setDepositInfo,
  setDepositFilter
} = financeSlice.actions;
